export default __webpack_public_path__ + "static/media/esferovite.396aa833.jpg";